<template>
    <room-video
        v-bind="{
            stream,
            enabled_audio,
            enabled_video,
        }"
    />
</template>

<script>
import { mapState } from "vuex";

import RoomVideo from "./room-video.vue";

export default {
    components: {
        RoomVideo,
    },
    computed: {
        ...mapState("interview/client", ["stream", "enabled_audio", "enabled_video"]),
    },
};
</script>

<style>
</style>